
export const handleFamilyContentChanges = ({
  index,
  field,
  value,
  formData,
  setFormData,
}) => {
  if (!formData?.familyMembers) return;

  const updatedFamily = [...formData.familyMembers];
  updatedFamily[index] = {
    ...updatedFamily[index],
    [field]: value,
  };

  setFormData({
    ...formData,
    familyMembers: updatedFamily,
  });
};
